import { formatOptionLabel, DropdownIndicator } from '@nile/components';
import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
import {
  reactSelectErrorStyles,
  reactSelectInlineError
} from '../../../Utils/style';

const ValueSelector = ({
  className,
  handleOnChange,
  options,
  isOptionDisabled,
  title,
  value,
  placeholder = 'Select an option',
  errors,
  disabled = false
}) => {
  let displayValue = undefined;
  options = options.map((item) => {
    if (item.name == value) displayValue = item;
    return {
      ...item,
      value: item.name
    };
  });

  if (options.length && options[0].options) {
    options = options.map((item) => {
      item.options = item.options.map((el) => {
        if (el.name == value) displayValue = el;
        return {
          ...el,
          value: el.name
        };
      });
      return item;
    });
  }

  const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: '14'
  };

  const formatGroupLabel = (data) => (
    <div style={groupStyles}>
      <span>{data.label}</span>
    </div>
  );

  const indicatorSeparatorStyle = {
    width: 0
  };

  const IndicatorSeparator = ({ innerProps }) => {
    return <span style={indicatorSeparatorStyle} {...innerProps} />;
  };

  if (typeof displayValue === 'undefined')
    displayValue = value ? { value: value, label: value } : '';

  return (
    /**
     * set portal target to body so that the dropdown does not go inside the parent container
     */
    <>
      <Select
        isDisabled={disabled}
        className={`${className}`}
        classNamePrefix="value_selector"
        formatGroupLabel={formatGroupLabel}
        formatOptionLabel={formatOptionLabel}
        value={displayValue}
        components={{
          IndicatorSeparator,
          DropdownIndicator
        }}
        title={title}
        onChange={(value) => handleOnChange(value)}
        options={options}
        placeholder={placeholder}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        closeMenuOnScroll={(e) => {
          return (
            e.target &&
            e.target.classList &&
            !(e.target.classList.value.indexOf('menu-list') > -1)
          );
        }}
        name="valueselector"
        menuShouldScrollIntoView={false}
        styles={
          errors
            ? {
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
                ...reactSelectErrorStyles
              }
            : {
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 })
              }
        }
        isOptionDisabled={isOptionDisabled}
      />
      {errors && reactSelectInlineError(errors[0])}
    </>
  );
};

ValueSelector.displayName = 'ValueSelector';

ValueSelector.propTypes = {
  value: PropTypes.string,
  options: PropTypes.array.isRequired,
  className: PropTypes.string,
  handleOnChange: PropTypes.func,
  title: PropTypes.string
};

export default ValueSelector;
